export default __webpack_public_path__ + "static/media/mena.b685b8a6.png";